<span aria-hidden="true" v-safe-html="svgHtml"></span>